var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.034,
    height: 30.354,
    viewBox: "0 0 39.034 30.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-home",
    "data-name": "Icon awesome-home",
    d: "M19,10.128,6.505,20.418V31.524a1.084,1.084,0,0,0,1.084,1.084l7.593-.02A1.084,1.084,0,0,0,16.262,31.5V25.018a1.084,1.084,0,0,1,1.084-1.084h4.337a1.084,1.084,0,0,1,1.084,1.084V31.5a1.084,1.084,0,0,0,1.084,1.088l7.591.021a1.084,1.084,0,0,0,1.084-1.084V20.41L20.035,10.128A.826.826,0,0,0,19,10.128Zm19.734,6.994-5.665-4.67V3.067a.813.813,0,0,0-.813-.813H28.46a.813.813,0,0,0-.813.813v4.92L21.58,3a3.253,3.253,0,0,0-4.134,0L.294,17.122a.813.813,0,0,0-.108,1.145l1.728,2.1a.813.813,0,0,0,1.146.11L19,7.35a.826.826,0,0,1,1.037,0l15.94,13.128a.813.813,0,0,0,1.145-.108l1.728-2.1a.813.813,0,0,0-.115-1.147Z",
    transform: "translate(0.001 -2.254)",
    fill: "#ed726f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.0cc4f67a391c13f7063f4841143f4798.svg";
export { ForwardRef as ReactComponent };